import { quotationApi } from 'utils/api';

export const getCategoryList = () => {
  return async dispatch => {
    await quotationApi.getCategoryList().then(response => {
      dispatch({
        type: 'GET_CATEGORY_LIST',
        data: response.data
      })
    }).catch(err => console.log(err))
  }
}

export const getQuestionList = (qttCtgrId) => {
  return async dispatch => {
    await quotationApi.getQuestionList(qttCtgrId).then(response => {
      dispatch({
        type: 'GET_QUESTION_LIST',
        data: response.data
      })
    }).catch(err => console.log(err))
  }
}

export const getResponseList = (freQttId) => {
  return async dispatch => {
    await quotationApi.getResponseList(freQttId).then(response => {
      dispatch({
        type: 'GET_QUOTATION_INFO',
        data: response.data
      })
    }).catch(err => console.log(err))
  }
}

export const insertQuotationInfo = (elem) => {
  return async dispatch => {
    await quotationApi.insertQuotationInfo(elem).then(response => {
      dispatch({
        type: 'INSERT_QUOTATION_INFO',
        data: response.data
      })
    }).catch(err => console.log(err))
  }
}

export const updateQuotationInfo = (elem) => {
  return async dispatch => {
    await quotationApi.updateQuotationInfo(elem).then(response => {
      dispatch({
        type: 'UPDDATE_QUOTATION_INFO',
        data: response.data
      })
    }).catch(err => console.log(err))
  }
}

export const insertResponseInfo = (elem) => {
  return async dispatch => {
    await quotationApi.insertResponseInfo(elem).then(response => {
    }).catch(err => console.log(err))
  }
}

export const deleteResponseInfo = (elem) => {
  return async dispatch => {
    await quotationApi.deleteResponseInfo({data: elem}).then(response => {
    }).catch(err => console.log(err))
  }
}
